export default {
  firebase: {
    apiKey: 'AIzaSyAlSCUvMYTTAXWSHfLQXrwK5H-IwpG2A1s',
    authDomain: 'sizzling-fire-1797.firebaseapp.com',
    databaseURL: 'https://sizzling-fire-1797.firebaseio.com',
    projectId: 'sizzling-fire-1797',
    storageBucket: 'sizzling-fire-1797.appspot.com',
    messagingSenderId: '77622098589',
    appId: '1:77622098589:web:c5f9ca1a8cdccd3702f274',
    measurementId: 'G-RWTPBWBSSR',
  },
  api: {
    url: 'https://api.uptrust.co',
    wss: 'wss://api.uptrust.co/graphql',
  },
  launchDarkly: {
    clientSideId: '60bff4368687860cdc0c318c',
  },
  datadogRUM: {
    applicationId: '6418ed95-72a0-4858-8e0a-16f99f052947',
    clientToken: 'pubd13d3055d1fd52f71e25cf93d9e3cb63',
    site: 'datadoghq.com',
    service: 'neo-staff-web',
    env: 'production',
    sampleRate: 100,
    version: import.meta.env.VITE_PUBLIC_VERSION,
    allowedTracingOrigins: ['https://api.uptrust.co'],
  },
};
